const FUNCTION_API_BASE = "https://sic-pdfwatermark.azurewebsites.net/api/";

export default FUNCTION_API_BASE;